import { useQuery } from "@apollo/client";
import { CMSPageByRouteQuery } from "../../queries/pageQueries";

const useCMSPageByRoute = ({
  route = null,
  locale,
}: {
  route: string;
  locale: string;
}) => {
  const { data, loading, error } = useQuery(CMSPageByRouteQuery, {
    variables: { route, locale },
    skip: !route,
  });
  return {
    page: data?.pageByRoute,
    loading,
    error,
  };
};

export default useCMSPageByRoute;
